
export const FILE_INDEX_REQUEST = 'FILE_INDEX_REQUEST';
export const FILE_INDEX_SUCCESS = 'FILE_INDEX_SUCCESS';
export const FILE_INDEX_ERROR = 'FILE_INDEX_ERROR';


export const FILE_UPLOAD_ERROR = 'FILE_UPLOAD_ERROR';
export const FILE_UPLOAD_REQUEST = 'FILE_UPLOAD_REQUEST';
export const FILE_UPLOAD_SUCCESS = 'FILE_UPLOAD_SUCCESS';
